import { IconProps } from "../types"

export const Icon = ({ src, width, height }: IconProps) => (
  <img src={`/img/${src}`} alt="my logotip" width={width} height={height} />
)